export default __webpack_public_path__ + "fc082c6ec5fa8d3ac46b6ae38ac78d45.png";